export function titleCase(str) {
  return str.toLowerCase()
    .split(' ')
    .map((word) => {
      if (typeof word[0] === 'string') {
        return word.replace(word[0], word[0].toUpperCase());
      }
      return word;
    })
    .join(' ');
}

export function symbolToSpace(str) {
  return str.trim().replace(/([_]|[^\w\d\s])/igm, ' ');
}

export function camelToTitle(str) {
  return str
    // Insert space before uppercase letters that are followed by a lowercase
    .replace(/([A-Z])(?=[a-z])/g, ' $1')
    // Capitalize the very first character
    .replace(/^./, match => match.toUpperCase())
    // Collapse acronyms: turn "S S T" back into "SST"
    .replace(/\b(?:[A-Z] ){2,}[A-Z]\b/g, match => match.replace(/ /g, ''));
}

export function toSentenceFromList(items) {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return items.join(' and ');
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
}



// WEBPACK FOOTER //
// ./src/utils/strings.js